module.exports = __webpack_public_path__ + "static/media/S3N1-6.fbfdad95.svg";